import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { GlgPopup } from 'SharedComponents'

import PopupTypes from '../../../popup_types'
import CreateCloneEventLeagueFormContent from './create_clone_event_league_form_content'

const CreateCloneEventLeaguePopup = ({
  onClose,
  show,
  formURL,
  onSave,
  getLeagueFieldDataSimGolf,
  getLeaguePotentialCloneCandidate,
  nextButton,
  data,
}) => {
  const [step, setStep] = useState( 1 )
  const [givenDays, setGivenDays] = useState([])
  const [startDate, setStartDate] = useState('')
  const [numberOfWeeks, setNumberOfWeeks] = useState('')
  const [selectedButton, setSelectedButton] = useState('manually')
  const [copyOptionsFields, setCopyOptionsFields] = useState({})
  const [selectedWeekDays, setSelectedWeekDays] = useState(
    {
      'Mon': ['Monday', false],
      'Tue': ['Tuesday', false],
      'Wed': ['Wednesday', false],
      'Thu': ['Thursday', false],
      'Fri': ['Friday', false],
      'Sat': ['Saturday', false],
      'Sun': ['Sunday', false],
    }
  )
  const [details, setDetails] = useState(
    {
      actionType: '',
      product: '',
      name: '',
      category: '',
      categoryName: '',
      season: '',
      seasonName: '',
      fromEventLeague: '',
      copyOptions: ['rounds_and_series'],
      rounds: [],
      weeklyRounds: [],
      manuallyRounds: [],
    }
  )

  useEffect(() => {
    if (data && !details.actionType) {
      setDetails({
        ...details,
        ...data,
        copyOptions: details?.copyOptions || ['rounds_and_series'],
        rounds: details?.rounds || [],
        weeklyRounds: details?.weeklyRounds || [],
        manuallyRounds: details?.manuallyRounds || [],
      })
    }
  }, [data])

  useEffect(() => {
    if (step === 1 && details && details.actionType === 'cloneEvent')
      setStep( 2 )
  }, [details])

  const isFinalStep = (details.actionType === 'cloneEvent' && step === 6) || (details.actionType === 'createEvent' && step === 5)

  const disableButtonAction = () => {
    let isDisabled = true
    if (details.actionType === 'cloneEvent') {
      if ((step === 5 && details.rounds.length <= 0) ||
          (step === 2 && details.fromEventLeague === '') ||
          (step === 3 && details.name.length <= 0))

        isDisabled = true
      else
        isDisabled = false
    } else if (details.actionType === 'createEvent') {
      if (details.name.length > 0)
        isDisabled = false
    }

    return isDisabled
  }

  const customPopupButtons = [
    {
      text: 'Back',
      class: 'custom_back_button',
      onClick: () => {
        setStep( step - 1 )
      }
    },
    {
      text: 'Next',
      class: `custom_next_button ${disableButtonAction() && 'disabled'}`,
      onClick: () => {
        if (!disableButtonAction())
          handleNext(details)
      }
    }
  ]

  const handleClose = () => {
    setStep( 1 )
    setGivenDays([])
    setStartDate('')
    setNumberOfWeeks('')
    setSelectedWeekDays({
      'Mon': ['Monday', false],
      'Tue': ['Tuesday', false],
      'Wed': ['Wednesday', false],
      'Thu': ['Thursday', false],
      'Fri': ['Friday', false],
      'Sat': ['Saturday', false],
      'Sun': ['Sunday', false],
    })
    setDetails({
      actionType: '',
      product: '',
      name: '',
      category: '',
      categoryName: '',
      season: '',
      seasonName: '',
      fromEventLeague: '',
      copyOptions: ['rounds_and_series'],
      rounds: [],
      weeklyRounds: [],
      manuallyRounds: [],
    })

    onClose(PopupTypes.CREATE_CLONE_EVENT_LEAGUE)
  }

  const handleNext = (data) => {
    setStep( step + 1 )
    nextButton(data)
  }

  return (
      <GlgPopup
        modalClass='create_clone_event_league general_sim_golf_popup'
        title={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.create_new_event_league_popup_title', { type: details.product ? details.product.charAt(0).toUpperCase() + details.product.slice(1) : 'Event or League' } ) }
        saveButtonText={ isFinalStep ? window.I18n.t('customer_center_menu.components.popups.sim_golf.create_event_button_text', { type: details.product ? details.product.charAt(0).toUpperCase() + details.product.slice(1) : 'Event' }) : '' }
        saveDisableWith={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.creating') }
        show={ show }
        onClose={ handleClose }
        customButtons={ step !== 1 ? ((step === 2 && details.actionType === 'createEvent') || isFinalStep) ? [customPopupButtons[0]] : customPopupButtons : [] }
        showSaveButton={ isFinalStep }
        showCloseButton={ false }
        onSave={ isFinalStep && onSave }
        formURL={ formURL }
      >
        <CreateCloneEventLeagueFormContent
          step={ step }
          setStep={ setStep }
          handleNext={ handleNext }
          getLeagueFieldDataSimGolf={ getLeagueFieldDataSimGolf }
          getLeaguePotentialCloneCandidate={ getLeaguePotentialCloneCandidate }
          details={ details }
          setDetails={ setDetails }
          copyOptionsFields={ copyOptionsFields }
          setCopyOptionsFields={ setCopyOptionsFields }
          givenDays={ givenDays }
          setGivenDays={ setGivenDays }
          startDate={ startDate }
          setStartDate={ setStartDate }
          numberOfWeeks={ numberOfWeeks }
          setNumberOfWeeks={ setNumberOfWeeks }
          selectedButton={ selectedButton }
          setSelectedButton={ setSelectedButton }
          selectedWeekDays={ selectedWeekDays }
          setSelectedWeekDays={ setSelectedWeekDays }
        />
      </GlgPopup>
    )
}

CreateCloneEventLeaguePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  formURL: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  getLeagueFieldDataSimGolf: PropTypes.func.isRequired,
  getLeaguePotentialCloneCandidate: PropTypes.func.isRequired,
  nextButton: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
}

export default CreateCloneEventLeaguePopup
